import {Fragment} from 'react';
import useGetLikedStores from '../../../../services/hookService/my-account/getLikedStores/useGetLikedStores';
import DotsLoading from '../../../../components/dotsLoading';
import SecondaryCard from '../../../../components/mazraeKit/cards/secondaryCard';
import {useNavigate} from 'react-router-dom';

const ShopsFavour = () => {
  const {data, isLoading} = useGetLikedStores();
  const navigate = useNavigate();
  return (
    <>
      <>
        {isLoading ? (
          <div className="d-flex w-100 justify-content-center pt-2">
            <DotsLoading />
          </div>
        ) : (
          <>
            {data?.length === 0 && (
              <p className="flex w-full text-center text-sm font-Medium justify-center py-4 text-gray-800">
                داده ای برای نمایش وجود ندارد!
              </p>
            )}

            {data?.map(item => (
              <Fragment key={item?.guid}>
                <SecondaryCard
                  rate={item?.store?.average_rate}
                  logo={item?.store?.logo || ''}
                  title={item?.store?.title}
                  state={item?.store?.state || ''}
                  city={item?.store?.city || ''}
                  cardWrapperClassName="w-full"
                  input_groups={item?.store?.store_type?.input_groups || []}
                  guid={item?.guid}
                  onClick={() =>
                    navigate(`/shop-card-detail/${item?.store?.guid}`)
                  }
                />
              </Fragment>
            ))}
          </>
        )}
      </>
    </>
  );
};

export default ShopsFavour;
